import {
  Question,
} from "@/models/quiz.model";
import { QuizRest } from "@/services/rest/quiz.rest";

import { BehaviorSubject, map, take } from "rxjs";

export class QuizServiceTeacher {
  constructor(private _quiz = new QuizRest()) {}

  private question$ = new BehaviorSubject(new Question());
  question = this.question$.asObservable();

  private questionAbstract$ = new BehaviorSubject({});
  questionAbstract = this.questionAbstract$.asObservable();

  getQuestionById(quizId: string, questionId: string): void {
    this._quiz
      .getQuestionById(quizId, questionId)
      .pipe(
        take(1),
        map((e) => {
          e.materialReferences?.forEach((ref) => {
            const totalMs = ref.referenceTime * 1000;
            const result = new Date(totalMs).toISOString().slice(11, 19);
            ref.referenceTime = result;
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.questionAbstract$.next(response);
        },
      });
  }

  getQuestionDefaultById(quizId: string, questionId: string): void {
    this._quiz
      .getQuestionDefaultById(quizId, questionId)
      .pipe(
        take(1),
        map((e) => {
          e.materialReferences?.forEach((ref) => {
            const totalMs = ref.referenceTime * 1000;
            const result = new Date(totalMs).toISOString().slice(11, 19);
            ref.referenceTime = result;
          });
          e.items?.forEach((item) => {
            const correct = e.correctItem.id === item.id ? true : false;
            item.correct = correct;
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.question$.next(response);
        },
      });
  }
 
}
